import { render, staticRenderFns } from "./segmentBase.vue?vue&type=template&id=7765b596&"
import script from "./segmentBase.vue?vue&type=script&lang=js&"
export * from "./segmentBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports